import { createJoonAPIClient } from "../../util/joon-api"

export const createResource = async (resource: FormData) => {
  const API = createJoonAPIClient()
  const response = await API.post("api/clinical-resources/", resource, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return response.data
}
